import React from 'react';

import video1 from 'assets/images/landingAir/air-insights/real-time-air-alert.mp4';
import video2 from 'assets/images/landingAir/air-insights/current-room-status.mp4';
import video4 from 'assets/images/landingAir/air-insights/life-saving-co-sensor.mp4';

import video1Thumbnail from 'assets/images/landingAir/air-insights/real-time-air-alert-thumbnail.jpg';
import video2Thumbnail from 'assets/images/landingAir/air-insights/current-room-status-thumbnail.jpg';

import video4Thumbnail from 'assets/images/landingAir/air-insights/life-saving-co-sensor-thumbnail.jpg';

import outdoorAirTracking from 'assets/images/landingAir/air-insights/outdoor-air-tracking.jpg';
import outdoorAirTrackingSm from 'assets/images/landingAir/air-insights/outdoor-air-tracking-sm.jpg';

export const airInsightsStatic = [
  {
    id: 1,
    duration: 10000,
    title: <>Real-time air alerts</>,
    content:
      'Mila tips you off when something isn\'t right, such as too-high humidity, poor outdoor air quality, or risk of mold in your home.',
    videoUrl: video1,
    poster: video1Thumbnail,
    image: '',
  },
  {
    id: 2,
    duration: 3000,
    title: <>Room Monitoring</>,
    content:
      'See how each room is doing at a glance. Is kitchen air creeping into the kids’ room? How’s the AQI with the windows open? Mila keeps tabs, so you don’t have to.',
    videoUrl: video2,
    poster: video2Thumbnail,
    image: '',
  },
  {
    id: 3,
    duration: 4000,
    title: (
      <>
        Carbon Monoxide Detection
      </>
    ),
    content:
      'Mila is the first air purifier to include a Carbon Monoxide sensor to protect you from potentially deadly dangers like malfunctioning furnaces or space heaters.',
    videoUrl: video4,
    poster: video4Thumbnail,
    image: '',
  },
  {
    id: 4,
    duration: 25000,
    title: <>Local Outdoor Air Tracking</>,
    content:
      'Mila even monitors your outdoor air quality, warning you about smog, pollen, wildfire smoke, and ozone—so you can make informed decisions to protect your health.',
    videoUrl: '',
    poster: '',
    image: {
      lg: {
        src: outdoorAirTracking,
        alt: 'Local Outdoor Air Tracking',
        width: 560,
        height: 404,
      },
      sm: {
        src: outdoorAirTrackingSm,
        alt: 'Local Outdoor Air Tracking',
        width: 306,
        height: 308,
      },
    },
  },

];
